<template>
    <div class='blog-list'>
        <div class="container header">
            <div class="columns">
                <div class="column is-10-widescreen is-offset-1-widescreen is-12-desktop">
                    <router-link :to="{name: 'blog'}">
                        <h1 class="title is-size-1 has-text-black has-text-weight-normal">Taskflex<span class="has-text-primary">Blog</span></h1>
                    </router-link>
                </div>
            </div>
        </div>

        <div class="container post" v-if="category">
            <div class="columns">
                <div class="column is-10-widescreen is-offset-1-widescreen is-12-desktop">
                    <div class="box has-background-primary category-title">
                        <div class="back-link">
                            <router-link :to="{ name: 'blog' }" class="level has-text-white">
                                <div class="level-left">
                                    <b-icon icon="arrow-left"></b-icon>
                                    Tilbage
                                </div>
                            </router-link>
                        </div>

                        <h2 class="title is-4 has-text-white" v-html="category.name" />
                    </div>
                </div>
            </div>
            <div class="columns">
                <div class="column is-10-widescreen is-offset-1-widescreen is-12-desktop">
                    <post-item v-for="post in posts" :key="post.id" :post="post"></post-item>
                </div>
            </div>


        </div>


        <div class="container loading" v-else>
            <div class="columns">
                <div class="column has-background-white is-10-widescreen is-offset-1-widescreen is-12-desktop has-text-centered">
                    <div>
                        <span>Indlæser..</span> <br>
                        <b-icon icon="loading" custom-class="mdi-spin" />
                    </div>
                </div>
            </div>
        </div>

        <br>
        <br>
    </div>
</template>


<style lang="scss" scoped>
    @import '../../../global/styles/_variables';

    .blog-list {
        background: $background-blueish;

        .header {
            padding-left: 1.5rem;
            padding-right: 1.5rem;

            .column {
                padding-top: 20px;
            }
        }

        .category-title {
            margin-bottom: 1rem;
            margin-top: 1rem;
            padding: 0.75rem;
            border-radius: 0;

            position: relative;

            h2 {
                text-align: center;
            }

            .back-link {
                position: absolute;
                left: 15px;
                top: 14px;

                &:hover {
                    text-decoration: underline;
                }
            }
        }

    }

</style>

<script>
    import PostItem from '@/taskflex/blog/components/PostItem';

    export default {
        data() {
            return {
                category: null,
                posts: null,
            };
        },

        computed: {
            slug() {
                return this.$route.params.slug;
            },
        },

        watch: {
            page() {
                this.load();
                window.scrollTo(0, 0);
            },
        },

        mounted() {
            this.load();
        },

        methods: {
            load() {
                this.$store
                // Currently locked to category 2 to allow prep work for blog redesign
                    .dispatch('blog/loadCategoryBySlug', { slug: this.slug })
                    .then((data) => {
                        this.category = data;

                        this.$store.dispatch('blog/fetchPostsForCategory', {
                            id: this.category.id,
                        }).then((posts) => {
                            this.posts = posts;
                        });
                    });
            },
        },

        components: {
            PostItem,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/blog/pages/Category.vue